$(document).ready(function() {
	if ($(window).width() > 992) {
		$('#content-scroll').overlayScrollbars({
			/* your options */
			sizeAutoCapable: true,
			paddingAbsolute: true,
			scrollbars: {
				clickScrolling: true
			}
		});
	}
});